import React from 'react';

import images from '../../../static/images/RealtorLanding';

export const CONSTANTS_COMMENTS = [
    images.sample1,
    images.sample2,
    images.sample3,
    images.sample4,
    images.sample5,
    images.sample6
];

export const PARAMS = (activeSlideIndex) => (
    {
        speed: 500,
        centerMode: true,
        variableWidth: true,
        spaceBetween: 30,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 807,
            settings: {
                speed: 5,
                centerMode: false,
                arrows: false,
                variableWidth: false,
                spaceBetween: 60,
                infinite: true,
                dots: true,
                fade: true,
                swipe: false,
                appendDots: dots => (
                    <div
                      style={{
                        width: '114px',
                        margin: '46px auto 0'
                      }}
                    >
                      <div
                        style={{
                          margin: '0px',
                          display: 'flex',
                          justifyContent: 'space-evenly'
                        }}
                      > {dots} </div>
                    </div>
                ),
                customPaging: (slideIndex) => (
                  <div
                    key={slideIndex}
                    style={
                      slideIndex !== activeSlideIndex ?
                      {
                        width: '8px',
                        height: '8px',
                        background: 'rgba(0, 166, 238, 0.2)',
                        borderRadius: '30px'
                      } : {
                        width: '8px',
                        height: '8px',
                        background: '#04AAEB',
                        borderRadius: '30px'
                      }
                    }
                  />
                )
            }
        }]
    }
);
